let _events = {};

let _state = {
  weather: undefined
};

const _update = function(weatherObj) {
  _state.weather = weatherObj;

  Object.keys(_events).forEach(eventID => {
    _events[eventID](_state.weather);
  });
};

const BG_IMG_DIR = `${process.env.PUBLIC_URL}/images/weather/`;

const _backgrounds = {
  'clear-day': `${BG_IMG_DIR}clear-day.jpg`,
  'clear-night': `${BG_IMG_DIR}clear-night.jpg`,
  'cloudy': `${BG_IMG_DIR}cloudy.jpg`,
  'fog': `${BG_IMG_DIR}fog.jpg`,
  'hail': `${BG_IMG_DIR}hail.jpg`,
  'partly-cloudy-day': `${BG_IMG_DIR}partly-cloudy-day.jpg`,
  'partly-cloudy-night': `${BG_IMG_DIR}partly-cloudy-night.jpg`,
  'rain': `${BG_IMG_DIR}rain.jpg`,
  'sleet': `${BG_IMG_DIR}sleet.jpg`,
  'snow': `${BG_IMG_DIR}snow.gif`,
  'thunderstorm': `${BG_IMG_DIR}thunderstorm.jpg`,
  'tornado': `${BG_IMG_DIR}tornado.jpg`,
  'wind': `${BG_IMG_DIR}wind.jpg`,
};

const get3HourIntervalWeather = function(hourlyWeather, numberOfHours = 5, startOffset = 0) {
  return hourlyWeather.filter((hourObj, index) => {
    return index % 3 === startOffset && index <= (3 * (numberOfHours - 1) + startOffset);
  });
};

const getWeatherBackgroundImage = function(icon) {
  return _backgrounds[icon];
}

const getSuggestedClothingForDay = function(day) {

  let clothing = new Set();
  const tempMax = day.apparentTemperatureMax;
  const tempMin = day.apparentTemperatureMin;
  const isVeryCold = tempMin < 35;
  const isModerateCold = tempMin < 40 && tempMin > 35;
  const isLightCold = tempMin < 45 && tempMin > 40;
  const isVeryWarm = tempMax > 85;
  const isModerateWarm = tempMax > 70 && tempMax < 85;
  const isLightWarm = tempMax > 60 && tempMax < 70;
  const isRainy = day.precipProbability > 0.45;
  const isSunny = day.cloudCover < 0.2;
  const isWindy = day.windSpeed > 25;

  if (isVeryCold) {
    clothing.add('hat');
    clothing.add('coat');
  }
  if (isModerateCold) {
    clothing.add('hoodie');
  }
  if (isLightCold) {
    clothing.add('sweater');
  }
  if (isVeryWarm) {
    clothing.add('bathing-suit');
  }
  if (isModerateWarm) {
    clothing.add('shorts');
    clothing.add('tshirt');
  }
  if (isLightWarm) {
    clothing.add('pants');
    clothing.add('tshirt');
  }
  if (isRainy) {
    clothing.add('umbrella');
  }
  if (isSunny) {
    clothing.add('sunglasses');
  }
  if (isWindy) {
    clothing.add('pants');
  }

  return [...clothing]
};

const formatTemperature = function(temp) {
  return `${Math.round(temp)}°`;
};

export {
  get3HourIntervalWeather,
  getWeatherBackgroundImage,
  getSuggestedClothingForDay,
  formatTemperature,
}



// WEBPACK FOOTER //
// ./src/utils/weather.js